/**
 * Circus Daily Style 2 correct/incorrect option surfaces (Figma 10003:4513).
 * Correct: dark green fill, brand green border + soft glow.
 * Incorrect: dark red fill, CD red border + soft glow.
 */

export const PICK_RESULT_CORRECT =
  'bg-success-500 border border-success shadow-[0_5px_10px_rgba(0,240,75,0.2)]';

export const PICK_RESULT_INCORRECT =
  'bg-error-500 border border-primary shadow-[0_5px_10px_rgba(224,33,37,0.25)]';

/** Selected option surface when results are known; otherwise null. */
export function getPickResultSurfaceClass(
  isSelected: boolean,
  isCorrect: boolean | null | undefined
): string | null {
  if (!isSelected || typeof isCorrect !== 'boolean') return null;
  return isCorrect ? PICK_RESULT_CORRECT : PICK_RESULT_INCORRECT;
}

/** True when grading has resolved to correct or incorrect (null/undefined = pending). */
export function hasPickResult(isCorrect: boolean | null | undefined): boolean {
  return typeof isCorrect === 'boolean';
}

/** Label color: white on result/default dark cards; dark text only on white selected cards. */
export function getPickOptionTextClass(isSelected: boolean, hasResult: boolean): string {
  return isSelected && !hasResult ? 'text-[color:var(--color-text-on-light)]' : 'text-white';
}
